import api from '../../../configs/instanceApi';

export const getProductsFromPsrsWithCnae = (primaryCnae, psrId) => {
  const url = `/accreditation-quotations/products?codePsr=${psrId}&codeCnae=${primaryCnae}`;
  return api.get(url);
};

export const getAllProductsAllowedByCnae = (codeCnae) => {
  const url = `/accreditation-quotations/products?codeCnae=${codeCnae}`;
  return api.get(url);
};
